// extracted by mini-css-extract-plugin
export var barContainer = "_4x-0";
export var extraThin = "_4x-3";
export var fillBar = "_4x-6";
export var fillContainer = "_4x-4";
export var overflow = "_4x-8";
export var overflowContainer = "_4x-5";
export var regular = "_4x-7";
export var thick = "_4x-1";
export var thin = "_4x-2";